import useSWR, { mutate } from 'swr';

import { fetcher, endpoints } from 'src/lib/axios';

const jobSwrOptions = { dedupingInterval: 10_000 } as const;

export function useJobPostingDetails(jobId: string | null | undefined) {
  const key = jobId ? endpoints.jobs.details(jobId) : null;
  return useSWR(key, fetcher, jobSwrOptions);
}

export function useJobWorkflowStages(jobId: string | null | undefined) {
  const key = jobId ? endpoints.jobs.workflowStages(jobId) : null;
  return useSWR(key, fetcher, jobSwrOptions);
}

export function useJobWorkflowStageCounts(jobId: string | null | undefined) {
  const key = jobId ? endpoints.jobs.stageCounts(jobId) : null;
  return useSWR(key, fetcher, jobSwrOptions);
}

export function revalidateJobWorkflowStageCounts(jobId: string) {
  return mutate(endpoints.jobs.stageCounts(jobId));
}
